import { render, staticRenderFns } from "./GopayPaymentPage.vue?vue&type=template&id=72526e3e&scoped=true&"
import script from "./GopayPaymentPage.vue?vue&type=script&lang=js&"
export * from "./GopayPaymentPage.vue?vue&type=script&lang=js&"
import style0 from "./GopayPaymentPage.vue?vue&type=style&index=0&id=72526e3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72526e3e",
  null
  
)

export default component.exports